define('container/moduleLoaders/AmdModuleLoader',['bluebird'], function(Promise) {

    'use strict';

    /**
     * Use this to load modules with requirejs.
     *
     * Service definition usage examples:
     *
     *      { module: 'path/to/module' }
     *      { module: 'path/to/module.specificExport' }
     */
    function AmdModuleLoader() {
    }

    AmdModuleLoader.prototype.canLoadModule = function(extensionApi) {
        return !!extensionApi.serviceDefinition.module;
    };

    AmdModuleLoader.prototype.loadModule = function(extensionApi) {

        var parts = extensionApi.serviceDefinition.module.split('.'),
            modulePath = parts[0],
            specificExport = parts[1];

        return new Promise(function(resolve, reject) {

            require(
                [modulePath],
                function(module) {

                    if (specificExport) {

                        if (module[specificExport]) {
                            return resolve(module[specificExport]);
                        }

                        return reject(new Error(
                            'Module "' + modulePath + '" does not export "' + specificExport + '".'
                        ));
                    }

                    resolve(module);
                },
                reject
            );

        });
    };

    return AmdModuleLoader;
});

